<template>
  <v-select
    v-model="selected"
    :items="items"
    v-bind="$attrs"
    :menu-props="{ bottom: true, offsetY: true }"
    flat
    solo
    :append-icon="null"
    :readonly="noInput"
    hide-details="auto"
  >
    <template #prepend>
      <v-btn v-if="jump && !noInput" icon :disabled="index <= 0 || item === null" small @click="start">
        <v-icon>mdi-chevron-double-left</v-icon>
      </v-btn>
      <v-btn v-if="!noInput" icon :disabled="index <= 0 || item === null" small @click="back">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </template>
    <template #selection>
      <span v-if="center" class="d-flex justify-center" style="width: 100%">
        {{ itemText }}
      </span>
      <span v-else>{{ itemText }}</span>
    </template>
    <template #append-outer>
      <v-btn v-if="!noInput" icon :disabled="index >= items.length - 1 || item === null" small @click="next">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn v-if="jump && !noInput" icon :disabled="index >= items.length - 1 || item === null" small @click="end">
        <v-icon>mdi-chevron-double-right</v-icon>
      </v-btn>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'SwitchSelect',
  props: {
    value: {
      type: [String, Number, Object],
      required: true,
    },
    noInput: {
      type: Boolean,
      default: false,
    },
    center: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      required: true,
    },
    jump: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selected: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    index() {
      return this.items.findIndex((item) => this.getItemValue(item) === this.selected)
    },
    itemText() {
      return this.$attrs['item-text'] ? this.item[this.$attrs['item-text']] : this.item
    },
    itemValue() {
      return this.$attrs['item-value'] ? this.item[this.$attrs['item-value']] : this.item
    },
    item() {
      return this.items.find((item) => this.getItemValue(item) === this.selected)
    },
  },
  created() {
    this.value = this.value ?? this.items[0]
  },
  methods: {
    getItemValue(item) {
      return this.$attrs['item-value'] ? item[this.$attrs['item-value']] : item
    },
    next() {
      if (this.index < this.items.length - 1) {
        this.selected = this.getItemValue(this.items[this.index + 1])
      }
    },
    back() {
      if (this.index > 0) {
        this.selected = this.getItemValue(this.items[this.index - 1])
      }
    },
    start() {
      this.selected = this.getItemValue(this.items[0])
    },
    end() {
      this.selected = this.getItemValue(this.items[this.items.length - 1])
    },
  },
}
</script>
